import { TMFeeAPI } from '@business/api/tm_fee';
import { TMFeeId, TMFeeResponse } from '@business/entities/tm';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { TMFeeFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditTMFeeModal/AddEditTMFeeModal';
import { switchMap } from 'rxjs/operators';

export class TMFeeBloc extends BaseBloc {
  private readonly typeRepo = new Repository<TMFeeResponse>({
    getItemId: item => item.id,
  });

  readonly tmFees$ = this.typeRepo.items$;
  readonly selectTMFee = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchTMFees = () => {
    return TMFeeAPI.fetchTMFees().pipe(this.typeRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  fetchTMFee = (id: TMFeeId) => {
    return TMFeeAPI.fetchTMFee(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_general_error') }),
    );
  };

  createTMFee = (data: TMFeeFormData) => {
    return TMFeeAPI.createTMFee(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_labour_type'),
      }),
    );
  };

  updateTMFee = (id: TMFeeId, data: TMFeeFormData) => {
    return TMFeeAPI.updateTMFee(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_labour_type'),
      }),
    );
  };

  deleteTMFee = (id: TMFeeId) => {
    return showDeleteConfirmation('Delete Categeory', 'Do you really want to remove this labour type?').pipe(
      switchMap(() => TMFeeAPI.deleteTMFee(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_labour_type'),
      }),
    );
  };
}
